export default {
  title: 'Signed / Live report',
  column_groups: {
    current_period: 'Current period',
  },
  fields: {
    name: 'Name',
    area: 'Area',
    signed: 'Signed',
    live: 'Live',
    going_live: 'Going live',
    going_live_avg: 'Going live avg',
    churned: 'Churned',
    not_live: 'Not live',
    live_ratio: 'Live ratio',
    avg_mrr: 'Avg MRR',
  },
  manager_status_filters: {
    active: 'Active',
    inactive: 'Inactive',
    all: 'All',
  },
  status_filters: {
    all: 'All',
    not_live: 'Not live',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} restaurant',
    subtitle_other: '{{count}} restaurants',
    empty: 'No restaurants found.',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data, please refresh the page',
  },
};
